import Flux from 'lib/flux';

const BookingConstants = Flux.createConstants({
  serviceMessages: ['REJECT', 'ACCEPT', 'SHOW'],
});

export default BookingConstants;
